import CtrlRegionais from './pages/CtrlRegionaisPage.vue'

const routes = [
  {
    path: 'ctrl-regionais',
    name: 'ctrl-regionais',
    component: CtrlRegionais
  }
];

export default routes;